<template>
  <div class="phone-yk-home-syn-que-wrapper">
    <el-form ref="Synthesis"
             class="yk-synthesis"
             label-width="100px"
             label-position="left">
      <el-form-item label="题干：">
        <div class="yk-claer-style-margin">
          <span class="yk-multiselect-question yk-span-wrapper"
                v-html="data.Content"></span>
        </div>
      </el-form-item>
      <el-form-item label="题干附件：" v-if="filesList.length > 0">
          <div v-if="IsTitle">
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
          <div v-else>
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
      </el-form-item>
      <div v-for="(item,index) in childQuestionList"
           :key="index+1">
        <el-form-item label="题目：">
          <span class="yk-synthesis-question yk-span-wrapper"
                v-html="item.questionTitle"
                style="float:left"></span>
          <span style="float:right;">
            <el-input placeholder="分值"
                      min="0"
                      max="100"
                      type="number"
                      v-model="item.Score"
                      disabled="disabled"
                      style="background:#fff;color:#fff;"></el-input>
          </span>
        </el-form-item>
        <el-form-item label="选项："
                      v-if="(item.QuestionType == 1 || item.QuestionType == 2) && IsTitle">
          <el-form-item v-for="(li,index1) in item.radioData"
                        :key="index1"
                        v-if="IsTitle">
            <el-radio :label="numstr[index1]"
                      v-show="item.QuestionType==1"
                      v-model="SubAnswers[index].Answers[0]"
                      @change="changeAnswers(index)">&nbsp;</el-radio>
            <el-checkbox-group v-model="SubAnswers[index].Answers"
                               v-show="item.QuestionType==2"
                               @change="changeAnswers(index)">
              <el-checkbox :label="numstr[index1]">{{selects[index1]}}.{{li}}</el-checkbox>
            </el-checkbox-group>
            <span v-if="item.QuestionType == 1">{{selects[index1]}}.</span>
            <span v-if="item.QuestionType == 1">{{li}}</span>
          </el-form-item>
        </el-form-item>
        <el-form-item label="选项："
                      v-if="(item.QuestionType == 1 || item.QuestionType == 2) && !IsTitle">
          <el-form-item v-for="(li,index1) in item.radioData"
                        :key="li">
            <span>{{selects[index1]}}.</span>
            <span>{{li}}</span>
          </el-form-item>
        </el-form-item>

        <el-form-item label="选项："
                      v-else-if="item.QuestionType == 3">
          <el-radio-group @change="changeAnswers(index)"
                          v-model="SubAnswers[index].Answers[0]">
            <el-radio label="1">对</el-radio>
            <el-radio label="0">错</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-show="IsList"
                      label="答案："
                      v-if="(item.QuestionType == 1 || item.QuestionType == 2)">
          <span v-for="(CheckValue,index2) in item.radio"
                :key="index2">{{selects[CheckValue]}};</span>
        </el-form-item>
        <el-form-item v-show="IsList"
                      label="答案："
                      v-else-if="item.QuestionType == 3">
          <span v-if="item.radio[0] == 1">对</span>
          <span v-else-if="item.radio[0] == 0">错</span>
        </el-form-item>
        <el-form-item v-show="IsList"
                      label="解析："
                      v-if="showThisAnswer">
          <div class="yk-clear-style-margin">
            <span class="yk-synthesis-question yk-span-wrapper"
                  v-html="item.analysisContent"></span>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="anaShow">
      <i class="el-icon-arrow-up"></i>
      <span>收起解析</span>
    </div>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="!anaShow">
      <i class="el-icon-arrow-down"></i>
      <span>查看解析</span>
    </div>
  </div>
</template>

<script>
// import SetQuestionScoreById from 'api/design/v1.design.Synthesis';
import QuestionFile from 'components/AliyunOSS/phoneQuestionFileNew.vue';
export default {
  components: {
    QuestionFile
  },
  props: {
    isBook:{
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    },
    childQuestionList: {
      default: function() {
        return [];
      }
    },
    childAnswerList: {
      default: function() {
        return [];
      }
    },
    IsList: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsTitle: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.jsonData.Id = this.data.Id;
    var answerIndex = 0;
    this.childQuestionList.forEach((element, index) => {
      if (
        this.childAnswerList[answerIndex] &&
        this.childAnswerList[answerIndex].Id === element.Id
      ) {
        this.SubAnswers.push(this.childAnswerList[answerIndex]);
        answerIndex += 1;
      } else {
        if (element.QuestionType === 2) {
          this.SubAnswers.push({
            Id: element.Id,
            ParentQuestionId: element.ParentQuestionId,
            Answers: []
          });
        } else {
          this.SubAnswers.push({
            Id: element.Id,
            ParentQuestionId: element.ParentQuestionId,
            Answers: ['']
          });
        }
      }
    });
    // 题目附件
    this.filesList = this.data.stemFiles;
  },
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      anaShow: true,
      showThisAnswer: true,
      selects: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V'
      ],
      numstr: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      jsonData: {
        Id: '',
        Answers: []
      },
      SubAnswers: []
    };
  },
  methods: {
    upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 添加正确答案
    addCheckValue: function() {
      this.CheckValues = this.check;
    },
    changeAnswers(index) {
      this.$emit('getAnswer', {
        jsonData: this.jsonData,
        SubAnswers: this.SubAnswers[index]
      });
    }
  }
};
</script>

<style lang="scss">
@import '~theme/page/components/variables.scss';
.phone-yk-home-syn-que-wrapper {
  position: relative;
  padding: 0 20px;
  background: #fff;
  .yk-synthesis {
    .yk-synthesis-question {
      p {
        margin: 0;
        padding: 0;
      }
    }
  }
  .el-radio__label {
    color: black;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;
    color: black;
  }
  .el-form-item__label,
  .el-form-item__content {
    color: black;
    font-size: 16px;
  }
  .yk-mm-up-down-wrapper {
    position: absolute;
    width: 240px;
    height: 30px;
    background: #f5f5f5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    bottom: -50px;
    left: 50%;
    margin-left: -120px;
    border-radius: 0 0 30px 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>

